'use strict';

import execute_on from "../../../../libs/execute-on";
import "dropzone";
import {getCsrfToken} from "../../../../plugins/get-csrf-token";
import {swalErrorFire, swalFire} from "../../../../plugins/sweet-alert/sweet-alert-default";

execute_on('admin.cms.instructions.edit', function () {
    const $dropzoneElement = $(".instructionsDropzone");
    $dropzoneElement.dropzone({
        url: $dropzoneElement.data('route'),
        addRemoveLinks: true,
        headers: {
            'X-CSRF-TOKEN': getCsrfToken()
        },
        maxFiles: 1,
        init: (function () {
            const dzClosure = this;
            $(".dz-submit").on('click', function (event) {
                event.preventDefault();
                dzClosure.processQueue();
            });
            dzClosure.on("success", function (file, response) {
                dzClosure.removeFile(file);
                if (response.errors.length > 0) {
                    swalErrorFire({
                        'title': 'Instructions import errors',
                        'html': '<ul>' + response.errors.map(error => '<li style="text-align: left;">' + error + '</li>').join('') + '</ul>',
                    });
                } else {
                    swalFire({
                        'title': 'Instructions import',
                        'html': 'The import of the instructions was successful',
                    })
                }
            });
        }),
        clickable: true,
        autoProcessQueue: false,
        acceptedFiles: '.xlsx',
        method: 'post',
    });
});
